var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.globalData)?_c('MainHeader',{attrs:{"data":_vm.globalData}}):_vm._e(),(_vm.$route.name!='unit')?_c('FooterBtn'):_vm._e(),_c('router-view'),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }